export default __webpack_public_path__ + "static/media/ville_real_1.1b50bf80.wav";